module.exports = __webpack_public_path__ + "static/img/case-dd-page-bg-09.fa5ee4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dd/case-dd-page-bg-09.jpg
// module id = ycVz
// module chunks = 1